import React from "react";

import HeaderNavLink from "../../HeaderNavLink";

const MyActivity = () => (
  <HeaderNavLink href="/lists">My Activity</HeaderNavLink>
);

export default MyActivity;
